import { render, staticRenderFns } from "./ContractCategoryItemPrimary.vue?vue&type=template&id=4742a3ac"
import script from "./ContractCategoryItemPrimary.vue?vue&type=script&lang=js"
export * from "./ContractCategoryItemPrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports